import { environment } from '../../../environments/environment';

export class UrlConstants {
	public static readonly CUSTOMER_SERVICE_PORTAL_URL = `${environment.customerServicePortalUrl}`;
	public static readonly BUSINESS_APPLICATION_URL = `${environment.businessApplicationAccessUrl}`;
}
